import { render, staticRenderFns } from "./previewPic.vue?vue&type=template&id=6e259ea8&scoped=true&"
import script from "./previewPic.vue?vue&type=script&lang=js&"
export * from "./previewPic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e259ea8",
  null
  
)

export default component.exports